import { Company } from "src/api-service";
import { AppError } from "../../../../app-store-error.types";

export interface CompaniesState {
    companies: Company[] | undefined;
    loaded: boolean;
    loading: boolean;
    error: AppError | null;
}

export const initialCompaniesState: CompaniesState = {
    companies: undefined,
    loaded: false,
    loading: false,
    error: null,
};
